import { Button, List } from "antd";
import { complexDigitToman, isEmpty } from "../../../../tools/tools";
import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { _adr } from "../../../../address";
import { useTranslation } from "react-i18next";
import { NotFound } from "../../../../sources/svg/svg";
import { BlackFriday } from "../../../auxiliary/icons/icons";
// strike-through (old) bundle price inside the promotion window, otherwise null.
// The bundle APIs send camelCase (showBeforePrice…); the PascalCase names are only a fallback.
export const promoBeforePrice = (b) => {
	const now = Date.now();
	const from = new Date(b?.showBeforePriceEffectiveDate ?? b?.ShowBeforePriceEffectiveDate).getTime();
	const to = new Date(b?.showBeforePriceExpiryDate ?? b?.ShowBeforePriceExpiryDate).getTime();
	return now >= from && now <= to ? (b?.showBeforePrice ?? b?.ShowBeforePrice) || null : null;
};
// spBundle rows -> one item per bundleSalesSimId: the lowest attributeOrderId is the bundle, the rest are its attributes
export const groupBundles = (rows = []) => {
	const bundleMap = {};
	rows.forEach((row) => {
		(bundleMap[row.bundleSalesSimId] ||= []).push(row);
	});
	return Object.values(bundleMap)
		.map((group) => {
			group.sort((a, b) => a.attributeOrderId - b.attributeOrderId);
			return { ...group[0], attribute: group.slice(1) };
		})
		.sort((a, b) => a.bundleOrder - b.bundleOrder);
};

const BundleList = ({ bundles, kitbundle, msisdn, iccid, fireSearch = false }) => {
	const nav = useNavigate();
	const [t] = useTranslation("global");

	const handleSelectBundle = async (e) => {
		e.preventDefault();
		let param = JSON.parse(e.target.closest("button").dataset.object);

		nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Msisdn, {
			state: {
				bundle: param,
				kit: kitbundle,
				msisdn: msisdn,
				iccid: iccid,
			},
		});

		// let tempMsisdn = msisdn.map((item) => {
		//   return { ...item, isgift: true };
		// });
		//dispatch(spForm({ kit: kitbundle, msisdn: tempMsisdn }));

		// dispatch(updateFormData({}));
	};

	return (
		<>
			{bundles.length > 0 && (
				<div className="holder-title-bundle-list">
					<h3>لطفا بسته مورد نظر را انتخاب کنید</h3>
				</div>
			)}
			<List
				dataSource={bundles}
				itemLayout="horizontal"
				size="large"
				locale={{
					emptyText: <>{msisdn.length > 0 && fireSearch && <NotFound text={"رکوردی یافت نشد."} />}</>,
				}}
				renderItem={(item, key) => (
					<div key={key} className="item">
						<div className="row-item">
							{new Date().getTime() >= new Date(item?.ShowBeforePriceEffectiveDate).getTime() &&
								new Date().getTime() <= new Date(item?.ShowBeforePriceExpiryDate) &&
								item?.activationPerSales == 2 && (
									<div className="special">
										{/* <svg xmlns="http://www.w3.org/2000/svg" width="74" height="77" viewBox="0 0 74 77" fill="none">
									<path
										d="M54.68 0.0624992L0 0.0624968L74 76.0625L74 19.3825C74 12.5486 74 9.13167 72.649 6.53081C71.5105 4.33909 69.7234 2.55204 67.5317 1.41354C64.9308 0.0624996 61.5139 0.0624995 54.68 0.0624992Z"
										fill="url(#paint0_linear_9065_110016)"
									/>
									<defs>
										<linearGradient
											id="paint0_linear_9065_110016"
											x1="83.9003"
											y1="-11.8677"
											x2="23.5207"
											y2="49.9126"
											gradientUnits="userSpaceOnUse">
											<stop stopColor="#B10000" />
											<stop offset="1" />
										</linearGradient>
									</defs>
								</svg>
								<div className="arrow-right">
									<span>
										ویژه <br />
										بلک فرایـــدی
									</span>
								</div> */}
										<BlackFriday />
									</div>
								)}
							<div className="title-sim">
								<h3>{item.bundleName}</h3>
								{!isEmpty(item.bundleSalesSimGiftId) && (
									<div className="gift">
										<div className="hold-gift">
											<i className="icon-gift"></i>
										</div>
										<span>همراه با سیم کارت هدیه</span>
									</div>
								)}
							</div>
							<div className="hold-desc">
								<h3>{item.attributeDescription}</h3>
								<p>
									{item.attribute.map((attr, key) => (
										<React.Fragment key={key}>{attr.briefDescription + " "} </React.Fragment>
									))}
								</p>
							</div>
							<div className="hold-price">
								{promoBeforePrice(item) && (
									<span className="oldprice">
										<span dir="ltr">{complexDigitToman(promoBeforePrice(item))}</span> تومان
									</span>
								)}
								<span>
									<span dir="ltr">{complexDigitToman(item.bundlePrice)}</span> تومان
								</span>
							</div>
							<div className="hold-aciton">
								<Button className="btn-package" data-object={JSON.stringify(item)} onClick={handleSelectBundle}>
									{t("simcardpurchase.msisdn.select")}
								</Button>
							</div>
						</div>
					</div>
				)}
			/>
		</>
	);
};

export default BundleList;
